<template>
  <div class="countdown-container">
    <div class="countdown-grid">
      <div class="countdown-item">
        <div class="countdown-number">{{ days }}</div>
        <div class="countdown-label">Hari</div>
      </div>

      <div class="countdown-item">
        <div class="countdown-number">{{ hours }}</div>
        <div class="countdown-label">Jam</div>
      </div>

      <div class="countdown-item">
        <div class="countdown-number">{{ minutes }}</div>
        <div class="countdown-label">Menit</div>
      </div>

      <div class="countdown-item">
        <div class="countdown-number">{{ seconds }}</div>
        <div class="countdown-label">Detik</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

// Updated target date to September 21, 2026 07:00 WIB
const targetDate = new Date("2026-09-21T07:00:00+07:00").getTime();
const days = ref(0);
const hours = ref(0);
const minutes = ref(0);
const seconds = ref(0);

const updateCountdown = () => {
  const now = new Date().getTime();
  const diff = targetDate - now;

  if (diff <= 0) {
    days.value = hours.value = minutes.value = seconds.value = 0;
    return;
  }

  days.value = Math.floor(diff / (1000 * 60 * 60 * 24));
  hours.value = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  minutes.value = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  seconds.value = Math.floor((diff % (1000 * 60)) / 1000);
};

onMounted(() => {
  updateCountdown();
  setInterval(updateCountdown, 1000); // Update every second for real-time seconds
});
</script>

<style scoped>
.countdown-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1.5rem;
}

.countdown-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  max-width: 900px;
  width: 100%;
}

.countdown-item {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  color: white;
  transition: transform 0.2s ease;
  min-height: 120px;
  min-width: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.countdown-item:hover {
  transform: translateY(-4px);
  background: rgba(255, 255, 255, 0.15);
}

.countdown-number {
  font-size: 2.2rem;
  font-weight: bold;
  line-height: 1;
  margin-bottom: 0.5rem;
}

.countdown-label {
  font-size: 1.1rem;
  opacity: 0.8;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Mobile (< 640px) */
@media (max-width: 639px) {
  .countdown-grid {
    grid-template-columns: repeat(4, 1fr);
    gap: 0.75rem;
    max-width: 520px;
  }

  .countdown-item {
    padding: 0.75rem 0.4rem;
    min-height: 75px;
    min-width: 60px;
  }

  .countdown-number {
    font-size: 1.5rem;
  }

  .countdown-label {
    font-size: 0.75rem;
  }
}

/* Tablet (640px - 1023px) */
@media (min-width: 640px) and (max-width: 1023px) {
  .countdown-grid {
    gap: 1.8rem;
    max-width: 750px;
  }

  .countdown-item {
    min-height: 100px;
    min-width: 75px;
  }

  .countdown-number {
    font-size: 2.6rem;
  }

  .countdown-label {
    font-size: 1.2rem;
  }
}

/* Desktop (>= 1024px) */
@media (min-width: 1024px) {
  .countdown-grid {
    gap: 1.8rem;
  }

  .countdown-item {
    padding: 1.4rem;
    min-height: 110px;
    min-width: 85px;
  }

  .countdown-number {
    font-size: 2.4rem;
  }

  .countdown-label {
    font-size: 1.1rem;
  }
}
</style>
